import { useCallback } from 'react';
import { useSearchStore } from '../store/searchStore';
import { useHistoryStore } from '../store/historyStore';
import { predictDay, departuresToDetails, type DepartureDetail } from '../services/predictionService';
import { fetchDepartures, formatDateForSogral } from '../services/sogralApi';
import { useLang } from '../i18n/translations';

const USE_MOCK = false;

/**
 * Logique de prédiction partagée entre le bouton « Analyser » et l'auto-run
 * de la page Planifier (affichage direct dès qu'un trajet + une date sont choisis).
 */
export function useRunPrediction() {
  const { agencyId, destinationId, date, setLoading, setPrediction, setError } = useSearchStore();
  const addHistory = useHistoryStore((s) => s.add);
  const { t } = useLang();
  const errorMsg = t.search.errorMsg;

  return useCallback(async () => {
    if (!destinationId || !date) return;
    setLoading(true);
    try {
      let source: 'live' | 'mock' = 'mock';
      let details: DepartureDetail[] = [];

      if (!USE_MOCK) {
        try {
          const d = new Date(date + 'T00:00:00');
          const rawDepartures = await fetchDepartures({
            agencyId, destinationId, date: formatDateForSogral(d), periode: 0,
          });
          if (rawDepartures.length > 0) {
            source = 'live';
            details = departuresToDetails(rawDepartures);
          }
        } catch { /* fallback */ }
      }

      const result = await predictDay(agencyId, destinationId, date);
      setPrediction(result, details, source);
      addHistory({ from_city: `agency-${agencyId}`, to_city: destinationId, date }, result.overall_level);
    } catch {
      setError(errorMsg);
    }
  }, [agencyId, destinationId, date, setLoading, setPrediction, setError, addHistory, errorMsg]);
}
